/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedOccupancyStatsResponseLeadsCountByBedTypeInner
 */
export interface BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    /**
     * Type of bed
     */
    bed_type: string;
    /**
     * Number of leads in this bed type
     */
    count: number;
}

/**
 * Check if a given object implements the BedOccupancyStatsResponseLeadsCountByBedTypeInner interface.
 */
export function instanceOfBedOccupancyStatsResponseLeadsCountByBedTypeInner(value: object): value is BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    if (!('bed_type' in value) || value['bed_type'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSON(json: any): BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    return BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSONTyped(json, false);
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    if (json == null) {
        return json;
    }
    return {
        
        'bed_type': json['bed_type'],
        'count': json['count'],
    };
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSON(json: any): BedOccupancyStatsResponseLeadsCountByBedTypeInner {
    return BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSONTyped(json, false);
}

export function BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSONTyped(value?: BedOccupancyStatsResponseLeadsCountByBedTypeInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bed_type': value['bed_type'],
        'count': value['count'],
    };
}

